var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 8.60002V5.60965M8 10.8165V10.8428M11.78 13.3333H4.22005C3.1874 13.3333 2.31595 12.6509 2.04177 11.7171C1.92473 11.3186 2.06854 10.9034 2.28851 10.5499L6.06846 3.73402C6.95407 2.31088 9.04594 2.31088 9.93154 3.73402L13.7115 10.5499C13.9315 10.9034 14.0753 11.3186 13.9582 11.7171C13.6841 12.6509 12.8126 13.3333 11.78 13.3333Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.8e628ff96eb4f7068c133ff9c6d0f713.svg";
export { ForwardRef as ReactComponent };